import React, { useState } from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import theme from '../../theme';
import Button from '../Agents/Button';
import { LeadCaptureDialog } from '../Agents/LeadCaptureDialog';

export function HomeHero(props) {

  const submitHandler = props.submitHandler;
  const responseStatus = props.responseStatus;
  const [dialogOpen, setDialogOpen] = useState(false);
  const { width } = useWindowDimensions();
  const wide = width >= 960;

  return (
    <View
      style={{
        paddingTop: theme.spacing.space16,
        paddingBottom: theme.spacing.space16 - 8,
        paddingHorizontal: theme.spacing.space12,
        maxWidth: wide ? 1120 : 760,
        alignSelf: 'center',
        width: '100%',
        flexDirection: wide ? 'row' : 'column',
        alignItems: wide ? 'center' : 'stretch',
      }}
    >
      <View style={{ flex: wide ? 1 : undefined, minWidth: 0 }}>
        <View
          style={{
            alignSelf: 'flex-start',
            backgroundColor: theme.colors.brandBlueTint,
            borderRadius: theme.radii.full,
            paddingVertical: theme.spacing.space1,
            paddingHorizontal: theme.spacing.space3 - 2,
            marginBottom: theme.spacing.space5,
          }}
        >
          <Text
            style={{
              fontFamily: theme.typography.fontMono,
              fontSize: theme.typography.size['2xs'],
              letterSpacing: theme.trackingPx(theme.typography.size['2xs'], 'widest'),
              textTransform: 'uppercase',
              color: theme.colors.accentPrimary,
            }}
          >
            Marketing analytics, unified
          </Text>
        </View>

        <Text
          style={{
            fontFamily: theme.typography.fontDisplay,
            fontWeight: theme.typography.weight.regular,
            fontSize: theme.typography.size['4xl'],
            lineHeight: theme.lineHeightPx(theme.typography.size['4xl'], 'tight'),
            letterSpacing: theme.trackingPx(theme.typography.size['4xl'], 'tight'),
            color: theme.colors.textPrimary,
            marginBottom: theme.spacing.space5 - 2,
          }}
        >
          Everything that explains your growth, in one place
        </Text>

        <Text
          style={{
            fontFamily: theme.typography.fontBody,
            fontSize: theme.typography.size.md,
            lineHeight: theme.lineHeightPx(theme.typography.size.md, 'normal'),
            color: theme.colors.textSecondary,
            marginBottom: theme.spacing.space8 - 2,
          }}
        >
          Attribution, GA4 data, Reporting, and Agents that answer questions in plain English — all running on the same connection to your warehouse.
        </Text>

        <View style={{ alignSelf: 'flex-start' }}>
          <Button variant="primary" size="lg" onPress={() => setDialogOpen(true)}>
            Book a demo
          </Button>
        </View>
      </View>

      <View
        nativeID="stk-hero-slot"
        style={{
          width: 300,
          height: 250,
          flexShrink: 0,
          marginLeft: wide ? theme.spacing.space12 : 0,
          marginTop: wide ? 0 : theme.spacing.space10,
        }}
      />

      <LeadCaptureDialog visible={dialogOpen} onClose={() => setDialogOpen(false)} onSubmit={submitHandler} responseStatus={responseStatus}/>
    </View>
  );
}

export default HomeHero;